import type { ReactNode } from 'react';

import { useIsComponentMounted } from 'hooks/useIsComponentMounted';
import useMartyContext from 'hooks/useMartyContext';
import { cn } from 'helpers/classnames';

interface ProductGalleryOverlayProps {
  children: ReactNode;
}

/**
 * Add to collection heart <3
 * Current limitation of this component is that it can only appear once on a page
 *  it gets confused with which parent to attach to
 * @returns {FunctionComponent}
 */
const ProductGalleryOverlay = ({ children }: ProductGalleryOverlayProps) => {
  const {
    marketplace: { is6pm }
  } = useMartyContext();
  // children are expected to be client only components
  const isMounted = useIsComponentMounted();
  const placementClasses = is6pm ? 'right-0 top-0' : 'right-5 top-5';
  return <div className={cn('absolute z-[5] flex items-center gap-2', placementClasses)}>{isMounted ? children : undefined}</div>;
};

export default ProductGalleryOverlay;
